<!--
    Summary:
        Y-染色体母血筛选
    ChangeLog:
        Labbor on 2020/2/22 added
-->
<template>
  <div class="v-y-chromosome-dna-test">
    <banner>
      <img src="../../assets/images/y-chromosome-dna-test/Header_1920x380_Y.jpg"/>
      <div slot="title">{{$t('YChromosomeDNATest.Title')}}</div>
    </banner>

    <div class="p1">
      <h2 class="h2" style="text-align: center; color: #cb3439; text-shadow: 1px 1px 2px #ffffff;">{{$t('YChromosomeDNATest.P1Title')}}</h2>
      <p>&nbsp;</p>
      <h5 class="h5" style="text-align: center; color: #ffffff; text-shadow: 1px 1px 2px #cb3439;">{{$t('YChromosomeDNATest.P1Detail')}}</h5>
    </div>

    <div class="p2">
      <img-card class="card" has-img>
        <div slot="title" style="width:100%;">{{$t('YChromosomeDNATest.P2Title')}}</div>
        <img slot="img" src="../../assets/images/y-chromosome-dna-test/Y-03.jpg"/>
        <p>{{$t('YChromosomeDNATest.P2Detail')}}</p>
        <p>&nbsp;</p>
        <p>{{$t('YChromosomeDNATest.P2Detail2')}}</p>
      </img-card>
    </div>

    <div class="p3">
      <div class="c">
        <h2 class="boy-title h2">{{$t('YChromosomeDNATest.P3Title')}}</h2>
        <img class="boy-img" src="../../assets/images/y-chromosome-dna-test/boy.jpg"/>
        <img class="girl-img" src="../../assets/images/y-chromosome-dna-test/girl.jpg"/>
        <h2 class="girl-title h2">{{$t('YChromosomeDNATest.P3Title2')}}</h2>
      </div>
    </div>

    <div class="p4">
      <img-card class="card" has-img>
        <div slot="title" style="white-space:nowrap;">{{$t('YChromosomeDNATest.P4Title')}}</div>
        <img slot="img" src="../../assets/images/y-chromosome-dna-test/Y-01.jpg"/>
        <p>
          {{$t('YChromosomeDNATest.P4Detail')}}<span style="color: #cb3439;">{{$t('YChromosomeDNATest.P4Detail_2')}}</span>{{$t('YChromosomeDNATest.P4Detail_3')}}
        </p>
        <p>&nbsp;</p>
        <p>
          {{$t('YChromosomeDNATest.P4Detail2')}}<span style="color: #368da7;">{{$t('YChromosomeDNATest.P4Detail2_2')}}</span>{{$t('YChromosomeDNATest.P4Detail2_3')}}
        </p>
      </img-card>
    </div>

    <div class="p5">
      <img-card class="card">
        <div slot="title">{{$t('YChromosomeDNATest.P5Title')}}</div>
        <ul>
          <li>{{$t('YChromosomeDNATest.P5Detail')}}</li>
          <li>{{$t('YChromosomeDNATest.P5Detail2')}}</li>
          <li>{{$t('YChromosomeDNATest.P5Detail3')}}</li>
        </ul>
      </img-card>
    </div>

    <div class="p6">
      <img-card class="card">
        <div slot="title">{{$t('YChromosomeDNATest.P6Title')}}</div>
        <div class="table-wrapper">
          <table id="cu-table">
            <thead></thead>
            <thead>
            <tr>
              <th>{{$t('YChromosomeDNATest.P6Row1Col1')}}</th>
              <th>{{$t('YChromosomeDNATest.P6Row1Col2')}}</th>
              <th>{{$t('YChromosomeDNATest.P6Row1Col3')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td :class="$i18n.locale=='en-US'?'leftmargin':''">{{$t('YChromosomeDNATest.P6Row2Col1')}}</td>
              <td>{{$t('YChromosomeDNATest.P6Row2Col2')}}</td>
              <td>{{$t('YChromosomeDNATest.P6Row2Col3')}}</td>
            </tr>
            <tr>
              <td :class="$i18n.locale=='en-US'?'leftmargin':''">{{$t('YChromosomeDNATest.P6Row3Col1')}}</td>
              <td>{{$t('YChromosomeDNATest.P6Row3Col2')}}</td>
              <td>{{$t('YChromosomeDNATest.P6Row3Col3')}}</td>
            </tr>
            <tr>
              <td :class="$i18n.locale=='en-US'?'leftmargin':''">{{$t('YChromosomeDNATest.P6Row4Col1')}}</td>
              <td>{{$t('YChromosomeDNATest.P6Row4Col2')}}</td>
              <td>{{$t('YChromosomeDNATest.P6Row4Col3')}}</td>
            </tr>
            <tr>
              <td :class="$i18n.locale=='en-US'?'leftmargin':''">{{$t('YChromosomeDNATest.P6Row5Col1')}}</td>
              <td>{{$t('YChromosomeDNATest.P6Row5Col2')}}</td>
              <td>{{$t('YChromosomeDNATest.P6Row5Col3')}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </img-card>
    </div>

    <div class="p7">
      <img-card class="card">
        <div slot="title">{{$t('YChromosomeDNATest.P7Title')}}</div>

        <div class="c box-wrapper">
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/y-chromosome-dna-test/Reproductive-health_icon-44.png"/>
            <div slot="sub-title">{{$t('YChromosomeDNATest.P7_1Title')}}</div>
            <div slot="sub-detail">{{$t('YChromosomeDNATest.P7_1Detail')}}</div>
          </box>
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/y-chromosome-dna-test/Reproductive-health_icon-45.png"/>
            <div slot="sub-title">{{$t('YChromosomeDNATest.P7_2Title')}}</div>
            <div slot="sub-detail">{{$t('YChromosomeDNATest.P7_2Detail')}}</div>
          </box>
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/y-chromosome-dna-test/Reproductive-health_icon-46.png"/>
            <div slot="sub-title">{{$t('YChromosomeDNATest.P7_3Title')}}</div>
            <div slot="sub-detail">{{$t('YChromosomeDNATest.P7_3Detail')}}</div>
          </box>
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/y-chromosome-dna-test/Reproductive-health_icon-29.png"/>
            <div slot="sub-title">{{$t('YChromosomeDNATest.P7_4Title')}}</div>
            <div slot="sub-detail">{{$t('YChromosomeDNATest.P7_4Detail')}}</div>
          </box>
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/y-chromosome-dna-test/Reproductive-health_icon-31.png"/>
            <div slot="sub-title">{{$t('YChromosomeDNATest.P7_5Title')}}</div>
            <div slot="sub-detail">{{$t('YChromosomeDNATest.P7_5Detail')}}</div>
          </box>
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/y-chromosome-dna-test/Reproductive-health_icon-27.png"/>
            <div slot="sub-title">{{$t('YChromosomeDNATest.P7_6Title')}}</div>
            <div slot="sub-detail">{{$t('YChromosomeDNATest.P7_6Detail')}}</div>
          </box>
        </div>
      </img-card>
    </div>

    <div class="p8">
      <img-card class="card">
        <div slot="title">{{$t('YChromosomeDNATest.P8Title')}}</div>

        <div class="c box-wrapper" >
          <box class="box" has-detail style="width:17.67%">
            <img src="../../assets/images/y-chromosome-dna-test/Reproductive-health_icon-06.png"/>
            <div slot="sub-detail">
              <div>{{$t('YChromosomeDNATest.P8_1Detail')}}</div>
              <div v-if="$i18n.locale=='en-US'">{{$t('YChromosomeDNATest.P8_1Details')}}</div>
              
              </div>
          </box>
          <box class="box" has-detail style="width:17.67%">
            <img src="../../assets/images/y-chromosome-dna-test/Reproductive-health_icon-14.png"/>
            <div slot="sub-detail">{{$t('YChromosomeDNATest.P8_2Detail')}}</div>
          </box>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </img-card>
    </div>
  </div>
</template>

<script>


  import banner from '@/components/banner'
  import imgCard from './img-card'
  import box from './box'
  import hoverBox from '@/components/hover-box'

  var rootClass = '.v-y-chromosome-dna-test', curTop, windowHeight = $(window).height(), count = 0;
  var preAnimation = function () {
    $(rootClass).find('img').addClass('img-slide-base');
  }
  var animation = function (e) {
    count++;
    curTop = window.scrollY;

    let $imgs = $(rootClass).find('img'), $img, imgTop, diff, len = $imgs.length;

    for (let i = 0; i < len; i++) {
      $img = $imgs.eq(i);
      imgTop = $img.offset().top;
      //console.log('animation', imgTop,  windowHeight)
      if (curTop === 0) {
        if (imgTop < windowHeight) { //首屏图片, 立刻开始动画
          $img.addClass('img-slide');
        }else{//不在第一屏的图片
          $img.removeClass('img-slide');
        }
      }
      else if (!$img.hasClass('img-slide')){
        diff = imgTop - curTop - windowHeight;
        if (diff < -10){ //误差
          $img.addClass('img-slide');
        }
      }
    }
  };
  window.onscroll = animation;

  export default {
    components: {
      banner,
      imgCard,
      hoverBox,
      box
    },
    data() {
      return {}
    },
    mounted() {
      preAnimation();
      animation();
    },
    methods: {},
  }
</script>

<style>
  .img-slide-base{
    transform: translateX(30px);
    transition: all 1s;
  }
  .img-slide{
    transform: translateX(0);
  }
</style>
<style scoped lang="scss">
  .v-y-chromosome-dna-test {
    text-align: left;

    .p1 {
      background-color: #e699b2;
      padding-top: 30px;
      padding-bottom: 30px;
    }

    .card {
      padding-bottom: 30px;
    }


    .box-wrapper {
      display: flex;

      & > div {
        width: 16.67%;
      }
    }

    .p3 {
      background-color: rgba(251, 207, 192, 0.2);
      padding-top: 60px;
      padding-bottom: 60px;

      .c {
        margin: 0 auto;
        display: flex;
        justify-content: center;

        img {
          width: 130px;
          height: 100%;
          margin-right: 20px;
        }

        img.boy-img {
          margin-right: 30px;
          margin-left: 20px;
        }

        .boy-title {
          padding-top: 30px;
          color: #546c97;
        }

        .girl-title {
          padding-top: 30px;
          color: #e699b2;
        }
      }
    }

    .p5 {
      background-color: rgba(251, 207, 192, 0.2);
      line-height: 27px;
      letter-spacing: 1px;
      font-size: 16px;

      ul {
        padding: 0;
        list-style: inside;
      }
    }

    .p7 {
      background-color: rgba(251, 207, 192, 0.2);
    }
  }
</style>

<style scoped lang="scss">
  .table-wrapper {
    text-align: center;
    line-height: 27px;
    letter-spacing: 1px;
    color: #3b3b3b;
    font-weight: 400;
    font-size: 16px;

    table#cu-table {
      padding-left: 5px !important;
    }

    table th {
      border: 0;
      padding: 5px 7px;
    }

    #cu-table caption {
      font-size: 2.532rem;
    }

    #cu-table {
      font-family: Microsoft\ JhengHei, sans-serif;
      border-collapse: collapse;
      width: 100%;
    }

    #cu-table th {
      padding: 1.2307em 1.2307em 1em;
    }

    #cu-table th {
      padding-top: 12px;
      padding-bottom: 12px;
      font-family: Microsoft\ JhengHei, sans-serif;
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      background-color: #efae9e;
      color: #fff;
    }

    #cu-table td {
      padding: .75em 1em .602em;
    }

    #cu-table tr:nth-child(even) {
      background-color: rgba(251, 207, 192, .2);
    }
  }
  .leftmargin{
    text-align: left;
    padding-left:100px !important;
  }
</style>




// WEBPACK FOOTER //
// src/view/genedetection/y-chromosome-dna-test.vue